export default "__VITE_ASSET__d2e0ccb0__"